<template>
  <mdc-dialog v-model="isOpen"
              :title="'user.add_client' | trans"
              :accept="'user.add' | trans"
              :cancel="'user.cancel' | trans"
              :accept-disabled="isAcceptDisabled"
              @accept="accept"
              @cancel="cancel">
    <div v-if="loading">
      <loader class="table-loader"></loader>
    </div>
    <div class="close-cross" @click="cancel()">
      <mdc-icon icon="close"></mdc-icon>
    </div>
    <div>
      <div v-if="!isItemsExists">
        {{'user.add_client_no_data' | trans}}
      </div>
      <form novalidate v-if="isItemsExists">
        <div class="form-group row">
          <div class="col-md-12">
            <select-with-pager id="mdc-client"
                               name="client_id"
                               class="load_more__select"
                               :label="'code'"
                               :selected=item
                               :options="itemsNew"
                               :searchable="false"
                               :filterable="false"
                               :loading=loading
                               :lastId=lastClientId
                               :isLastPage=isLastPageClient
                               :class="{'is-invalid': errors.has('therapist_id'), 'is-clear': !item}"
                               v-on:next-page="nextClientPage"
                               v-bind:isLast="isLastClient"
                               v-bind:getOptionTitle="getOptionClientTitle"
                               v-on:set-selected="onChangeClinicId"/>

            <label class="mdc-floating-label" :class="{ 'mdc-floating-label-error': errors.has('therapist_id') }">{{ 'user.choose_client_from_list' | trans }}</label>
          </div>
        </div>
      </form>
    </div>
  </mdc-dialog>
</template>

<script>

  import Loader from '../../../loader/components/Loader'
  import TherapistApiManager from '../../api/therapist'
  import selectWithPager from '../../../../common/selectWithPager/components/SelectWithPager';

  export default {
    name: 'AttachClientModal',
    components: {Loader, selectWithPager},
    data () {
      return {
        items: [],
        item: null,
        lastClientId: null,
        isLastPageClient: false,
        perPage: 10,
        page: 1,
        state: {
          disabled: false,
          loadingCount: 0,
        },
      }
    },
    props: {
      visible: {
        required: true,
        type: [Boolean],
      },
      therapistId: {
        required: true,
        type: [Number, String],
      },
    },
    computed: {
      isOpen: {
        get: function () {
          return this.visible
        },
        set: function () {
        },
      },
      loading: {
        get: function () {
          return this.state.loadingCount > 0
        },
        set: function (newVal) {
          if (newVal === false) {
            this.state.loadingCount--
            return
          }
          this.state.loadingCount++
        },
      },
      itemsNew() {
        return this.items.filter((item) => {
          if (this.item) {
            return item.id !== this.item.id
          }
          else {
            return true
          }
        })
      },
      isItemsExists: function () {
        return this.items.length > 0
      },
      isAcceptDisabled () {
        return this.state.disabled || !this.isItemsExists
      },
    },
    methods: {
      setLoading: function (state) {
        this.loading = state
        this.$emit('loading', state, this.state.created)
      },
      accept: function () {
        this.$emit('accept', this.item.id)
      },
      cancel: function () {
        this.$emit('cancel')
      },
      fetchData: async function () {
        this.setLoading(true)

        let response = await TherapistApiManager.paginateAllClientsByTherapistId({
          therapistId: this.therapistId,
          perPage: this.perPage,
          page: this.page,
          isOwn: 0,
        })

        this.items = response.data.data.items

        if (this.items.length) {
          this.disabledClient = false
          this.lastClientId = this.items[this.items.length - 1].id;
          if (response.data.data.lastPage != this.page) {
            this.page++;
          } else {
            this.isLastPageClient = true;
          }
        }
        this.setLoading(false)
      },

      getOptionClientTitle: function ({option}) {
        return option.code;
      },

      onChangeClinicId: function (selected) {
        this.item = selected;
      },

      nextClientPage: async function () {
        if (!this.isLastPageClient) {
          this.loading = true;
          let response = await TherapistApiManager.paginateAllClientsByTherapistId({
            therapistId: this.therapistId,
            perPage: this.perPage,
            page: this.page,
            isOwn: 0,
          })
          response.data.data.items.forEach((item) => {
            this.items.push(item)
          });
          this.lastClientId = this.items[this.items.length - 1].id;
          if (this.page == response.data.data.lastPage) {
            this.isLastPageClient = true;
          } else {
            this.page++;
          }

          if (response) {
            this.loading = false;
          }
        }
      },

      isLastClient: function ({option}) {
        return option.id == this.lastClientId;
      }
    },
    watch: {
      visible: function (newVal, oldVal) {
        if (newVal === true) {
          this.fetchData()
        } else {
          this.item = null
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/modules/user/therapist/profile/AttachClientModal.vue